// @ts-check
import React from 'react'

/**
 * @param {{
 * children: React.ReactNode,
 * href: string,
 * title?: string,
 * target?: '_blank' | '',
 * className?: string}} props
 */
const Link = (props) => (
  <a {...props} rel='noopener noreferrer'>
    {props.children}
  </a>
)

Link.defaultProps = {
  href: '#',
  title: '',
  target: ''
}

export { Link }
